import { PUBLIC_CARRIER_COOKIE } from 'core/domain/Carrier'
import { cookieClient, type CookieClient } from 'core/infra/cookie'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { SpotQuoteRepository } from '../infra/SpotQuoteRepository'

export type GetSpotQuoteFactoryDependencies = {
  spotQuoteRepository: SpotQuoteRepository
  cookie: CookieClient
}

export function getSpotQuoteFactory({
  spotQuoteRepository,
  cookie,
}: GetSpotQuoteFactoryDependencies) {
  return async function getSpotQuoteById(id: string, config?: { signal?: AbortSignal }) {
    const spotQuote = await spotQuoteRepository.getSpotQuoteById(id, config)

    cookie.setCookie(PUBLIC_CARRIER_COOKIE, spotQuote.carrier)

    return spotQuote
  }
}

export function getSpotQuote(id: string, config?: { signal?: AbortSignal }) {
  const httpClient = new ShipperGuideClient()
  const spotQuoteRepository = new SpotQuoteRepository({ httpClient })
  const get = getSpotQuoteFactory({ spotQuoteRepository, cookie: cookieClient })

  return get(id, config)
}
